module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"discount":"Скидка","current":"Текущий","perMonth":"в месяц","every":"каждые | каждый | каждые | каждые","months":"месяцев | месяц | месяца | месяцев","addDiscount":"Доп.скидка"}}')
  delete Component.options._Ctor
}
